/** Full-page navigation, in one place so tests can mock it (jsdom does not
 *  implement `window.location.assign`). */
export function assignLocation(url: string): void {
  window.location.assign(url);
}
